export const DISCHARGE_FOLDER_CODE = 'discharge';

export const DISCHARGE_FULL_PERFORMANCE_CERTIFICATE_PREFIX = 'Discharge.CertificateOfFullPerformance';
export const DISCHARGE_SRD_REPORT_PREFIX = 'Discharge.SRDReport';
export const DISCHARGE_FORM_58 = 'Discharge.Form58';
export const DISCHARGE_DIVIDENT_CHECKLIST = 'Discharge.DividendChecklist';
export const DISCHARGE_SRD_CHECKLIST = 'Discharge.SRDChecklist';
export const DISCHARGE_FORM_16 = 'Discharge.Form16';
export const DISCHARGE_FORM_15 = 'Discharge.Form15';
